import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './plugins/vuei18';
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import "./style/global.sass";
import VueMask from "v-mask";
import { ComboEnum, IUtilidades, Utilidades } from './Util/Utilidades'
import VueI18n from 'vue-i18n'
import { Constantes } from './Util/Constantes'
import { AuthService } from './services/Auth'

const requireComponent = require.context(
  "@/components",
  false,
  /[A-Z]\w+\.(vue|js)$/
);
const originalToFixed = Number.prototype.toFixed;

declare module 'vue/types/vue' {
  interface Vue {
    $utilidades: IUtilidades;
    $traduccion: ({ texto, tag }: { texto: string, tag?: string }) => { result: string };
    $toFixed: (item: number | string, digits?: number) => { result: string };
    $combo: any;
  }
}

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.config.productionTip = false

store.commit("setApiUrl", process.env.VUE_APP_API_URL);

Vue.use(VueMask);
Vue.prototype.$utilidades = Utilidades;
Vue.prototype.$traduccion = function ({ texto, tag }) { return Utilidades.traduccion({ texto, tag }) };
Vue.prototype.$toFixed = function (item: number | string, digits = 2 as number) { return Utilidades.toFixed(item, digits) };
Vue.prototype.$combo = ComboEnum;

//@ts-ignore
Number.prototype.toFixed = function (digits: number) {
  if (this === null || this === undefined) {
    return this;
  } else {
    return originalToFixed.call(this, digits);
  }
}

const GlobalMethodsPlugin = {
  install() {
    Vue.prototype.toFixed = Number.prototype.toFixed;
  },
};

Vue.use(GlobalMethodsPlugin);

Vue
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
